<script>
  import { resolveStatusClass } from '@utils/status'

  export default {
    props: {
      status: {
        type: Object,
        required: true
      },
      extraClasses: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        finishedLoading: false,
      }
    },
    computed: {
      statusKey (){
        if (this.status && this.status.key){
          return this.status.key
        }
        return ''
      }
    },
    async created() {
      this.finishedLoading = true
    },
    methods: {
      resolveStatusClass,
    }
  }
</script>

<template>
  <div class="dropdown-default-line">
    <button type="button" class="btn btn-secondary btn-block btn-dropdown">
      <span
        class="status-item"
        :class="[
          resolveStatusClass(statusKey.toLowerCase()),
        ]"
      >{{ status.name }}</span>
    </button>
  </div>
</template>
